export const SEQUENCER_FEE_AMOUNT_USDC = 1;
